import React from 'react';
import { useHistory } from 'react-router-dom';
import { Empty, Row } from 'antd';

import { buildPropertyBaseUri } from 'utils/routes';

import Image from 'components/Image/BareImage/BareImage';
import { Spin } from 'antd';

import { FieldTimeOutlined } from '@ant-design/icons';

import {
  CardContainer,
  StyledCard,
  StyledCardImageContainer,
  StyledEmpty,
  StyledTextUnitAddress,
  StyledTextUnitName,
  StyledTextAvailability
} from './Body.styles';

const CardHeader = ({ image, onClick, availability }) => {
  return (
    <StyledCardImageContainer>
      <Image image={image} alt="View of the property" onClick={onClick} />
    </StyledCardImageContainer>
  );
};

const CardBody = ({ unitName, unitState, onClick, availability }) => {
  const unitAddress = `${unitState}`;

  return (
    <div onClick={onClick}>
      <StyledTextUnitName>{unitName}</StyledTextUnitName>
      <StyledTextUnitAddress>{unitAddress}</StyledTextUnitAddress>
      {availability !== undefined && (
        <StyledTextAvailability>
          {availability === 0 ? (
            <div>
              <FieldTimeOutlined />
              {`\t Sold Out!`}
            </div>
          ) : availability === 1 ? (
            `${availability} more room left!`
          ) : (
            `${availability} more rooms left!`
          )}
        </StyledTextAvailability>
      )}
    </div>
  );
};

const Body = ({ stateMYSelection, hostId, properties = [], filterState, filterProp }) => {
  const history = useHistory();

  const handleOnPropertyClick = propertyId => () => {
    // console.log(buildPropertyBaseUri(hostId, propertyId));
    history.push(buildPropertyBaseUri(hostId, propertyId));
  };
  let props = properties;

  if (!!filterState) {
    props = props.filter(property => property.state === filterState);
  }
  if (!!filterProp) {
    props = props.filter(property => property._id.toString() === filterProp.toString());
  }

  return props.length > 0 ? (
    <Row>
      {props.map(property => {
        const propertyId = property._id;
        const firstImage = property.images.length > 0 ? property.images[0].imageUrl : undefined;
        const propertyName = property.bookingEngine ? property.bookingEngine.displayName : property.name;
        const propertyState = stateMYSelection.find(state => state.value === property.state)
          ? stateMYSelection.find(state => state.value === property.state).label
          : property.state;
        const availability = property.actualAvailability;

        return (
          <CardContainer key={propertyId} span={24} md={8} xl={8}>
            <StyledCard cover={<CardHeader image={firstImage} onClick={handleOnPropertyClick(propertyId)} />}>
              <CardBody unitName={propertyName} unitState={propertyState} onClick={handleOnPropertyClick(propertyId)} availability={availability} />
            </StyledCard>
          </CardContainer>
        );
      })}
    </Row>
  ) : (
    <>
      {/* <Spin size="large" /> */}
      <StyledEmpty image={null} description={<Spin size="large" />} />
      <StyledEmpty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Loading Data..." />
    </>
  );
};

export default Body;
